export default __webpack_public_path__ + "static/media/241315877_406683204149037_5521376708609917040_n.a4c91727.png";